// extracted by mini-css-extract-plugin
export default {"clientInfoUnit":"ClientInfoUnit_clientInfoUnit__kiDIW","clientInfoUnitPhone":"ClientInfoUnit_clientInfoUnitPhone__fL-2s ClientInfoUnit_clientInfoUnit__kiDIW"};